import React, {useEffect, useState} from "react";
import {IconButton} from "@vkontakte/vkui";
import {BsArrowLeft} from "react-icons/bs";

const PreviewPhotos = ({photos, sizes, id, goBack}) => {
    const [sortedPhotos, setSortedPhotos] = useState([])
    useEffect(() => {
        const safeSizes = Array.isArray(sizes) ? sizes.filter(Boolean) : [];
        const safePhotos = Array.isArray(photos) ? photos.filter(Boolean) : [];
        let it = [];

        for (let i = 0; i < safeSizes.length; i++) {
            const sizeId = safeSizes[i] && safeSizes[i]._id;
            it.push({
                label: safeSizes[i].label || "Размер",
                photos: safePhotos.filter(x => x && x.selectedSize && x.selectedSize._id === sizeId)
            })
        }
        setSortedPhotos([...it])
    }, [photos, sizes])
    return (
        <div className="preview_photos_portal_shell" role="dialog" aria-modal="true" aria-label="Просмотр фотографий заказа">
            <div className={"preview_panel_modal vkuiView__popout View__popout"}>

                <div className={"header_prrev"}>
                    <IconButton onClick={() => goBack()} style={{
                        width: 40,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <BsArrowLeft size={25}/>
                    </IconButton>
                    <span className={"font_montserrat w_700"} style={{fontSize: 25, marginLeft: 10}}>Ваш заказ:</span>
                </div>
                <div className={"preview_div"}>
                    {sortedPhotos && sortedPhotos.map((item, groupKey) => {
                        if (item.photos.length > 0)
                            return (
                                <div className={"photos_sort"} key={`group-${groupKey}`}>
                                    <span className={"font_montserrat w_700"}>{item.label}</span>
                                    <div className={"photos_labl"}>
                                        {item.photos && item.photos.map((photoItem, photoKey) => {
                                            return (
                                                <div key={`${groupKey}-${photoKey}-${photoItem.photo || photoKey}`} className={"preview_photo"}>

                                                    <img src={photoItem.url} alt="" className={"preview_img_"}/>
                                                    <div className={"prev_info"}>
                                {/*<span
                                    className={"font_montserrat w_500"}>Вид печати: {item.selectedSize && item.selectedSize.label}</span>*/}
                                                        <span
                                                            className={"font_montserrat w_500"}>{photoItem.count ? photoItem.count : 1} шт.</span>
                                                    </div>

                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )
                    })}
                </div>
            </div>
        </div>

    )
}

export default PreviewPhotos;
